'use client';
import { Button } from '@ahafood/ui/components/button';
import { assetPrefix } from '@ahm/api-wrappers-core';
import { ChevronLeft } from 'lucide-react';
import React from 'react';
import HotDealIcon from '@/../public/static/icons/hot-deal-title.svg';
import { useRouter } from '@/i18n/routing';
import { trackEvent } from '@/lib/event-tracking';

export default function HotDealHeader() {
  const router = useRouter();
  return (
    <div className="bg-white fixed top-0 inset-x-0 flex justify-between items-center container py-2 z-[99] px-0 max-w-screen-xl w-full mx-auto">
      <div className="bg-[#FFF8F2] flex justify-between items-center w-full px-3 py-2 rounded-md">
        <div className="flex gap-4">
          <Button
            variant="ghost"
            className="mt-1 font-medium [&_svg]:size-6 bg-neutral-30 rounded-full [&_svg]:stroke-2 [&_svg]:text-white size-8"
            onClick={() => {
              trackEvent('click_button', {
                action_time: Math.floor(Date.now() / 1000),
                button_name: 'is_back',
                button_location: 'flash_deal_zone',
              });
              router.back();
            }}
          >
            <ChevronLeft />
          </Button>
          <div className="flex flex-col text-xs">
            <HotDealIcon className="w-auto h-10" aria-hidden="true" />
            <span>Ăn ngon – uống tràn</span>
            <span>Deal hot – ngập tràn</span>
          </div>
        </div>
        <div className="aspect-[110/123] w-28 -my-4 mr-2 rounded-md overflow-hidden">
          <img
            src={`${assetPrefix}/static/images/deal-header-image.webp`}
            alt=""
            className="size-full object-cover"
          />
        </div>
      </div>
    </div>
  );
}
